import { z } from "zod";
import { adminUlidSchema } from "./admin-operations-core.js";
import { adminSupportQueueSummarySchema } from "./admin-operations-support.js";
export const adminRelatedConversationsCommandSchema = z
    .object({
    view: z.literal("RELATED_CONVERSATIONS"),
    ticketId: adminUlidSchema,
    cursor: z.string().min(1).max(4096).optional(),
})
    .strict();
export const adminRelatedConversationsResponseSchema = z
    .object({
    data: z
        .object({
        ticketId: adminUlidSchema,
        conversations: z.array(adminSupportQueueSummarySchema).max(25),
        nextCursor: z.string().max(4096).nullable(),
        coverage: z.literal("CURRENT_RETAINED_REQUESTS"),
    })
        .strict(),
})
    .strict();
export const adminInternalNameCommandSchema = z
    .object({
    operatorId: z.string().min(1).max(128),
    displayName: z
        .string()
        .trim()
        .min(1)
        .max(40)
        .refine((v) => ![...v].some((c) => c.charCodeAt(0) < 32 || c.charCodeAt(0) === 127 || "@<>".includes(c)), "Use an internal name, not an email address."),
    expectedVersion: z.number().int().nonnegative(),
    commandId: z.string().uuid(),
})
    .strict();
export const adminInternalNameResponseSchema = z
    .object({
    data: z
        .object({
        operatorId: z.string().min(1).max(128),
        displayName: z.string().min(1).max(40),
        version: z.number().int().positive(),
        verification: z.literal("OWNER_PROVIDED_INTERNAL_NAME"),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-support-experience.js.map